const SignatureModes = {
  FULL_SIGNATURE: window.Core.Tools.SignatureCreateTool.SignatureTypes.FULL_SIGNATURE,
  INITIALS: window.Core.Tools.SignatureCreateTool.SignatureTypes.INITIALS,
};

export default SignatureModes;